import React from "react";
import Grid from "@material-ui/core/Grid";
import { CSSTransition} from 'react-transition-group';
import {withRouter } from "react-router-dom";
import PrizeProgress from "../../pageComponents/Home/PrizeProgress";
import backgroundImage from "../../../assets/images/main_background.png";
import star from "../../../assets/images/img_star.png";
import goldCoin from "../../../assets/images/ic_coin.png";
import silverCoin from "../../../assets/images/ic_silver_coin.png";
import startButton from "../../../assets/images/ic_start_btn.png";
import starShow from "../../../assets/images/img_star_show.png";
import roundLight from "../../../assets/images/img_raund_light.png";
import giftBox from "../../../assets/images/box_gift.png";
import giftHallBackground from "../../../assets/images/gift_hall_invis.png";
import blurBackground from "../../../assets/images/homeOneOfThree.png";
import gardoone from "../../../assets/images/img_gardone.png";
import coinBox from "../../../assets/images/ic_coins.png";
import GoldBanner from "../../../assets/images/gold_banner.png";
import FreeCoinItem from "../../pageComponents/Home/FreeCoinItem";
import '../../../App.scss';
import Toolbar from "../../Toolbar";
import { bounce } from 'react-animations';
import Radium from 'radium';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CustomDialog from "../../pageComponents/Common/Dialog";
import Exit from "../../../assets/images/exit.png";
import {connect} from "react-redux";
import {data} from "../../../Store/Actions/DataAction";
import axios from "axios";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
import {actionMainGet, dailyGift, giftHallCheck, giftLogoCheck, giftLogoGet, userData} from "../../../Utility/Url";
import {numberSplitor} from "../../../Utility/Func";
import BoxDialog from "../../pageComponents/Common/BoxDialog";
import SpecialOfferDialog from "../../pageComponents/Common/SpecialOfferDialog";
import {dialogBackground, dialogBorderColor, dialogContentColor, dialogContentTextColor
} from "../../../Utility/Theme";
import {COINCHANGE} from "../../../Store/Actions/Types";
class HomeIndex extends React.Component {
    constructor(props) {
        super(props)
        this.state={
            rxDataLoaded:false,
            allDataLoaded:false,
            trueState:true,
            appHasLoaded:false,
            showDialog:false,
            giftHallCheck:null,
            specialDialogData:null,
            boxDialog:false,
            giftLogoCheck:false,
            dailyGift: {},
            boxDetail:{
                success: true,
                light:roundLight,
                type: "gift",
                strAction: "بریم  بازی",
                action: "#game",
                imgUrl: 'http://hooshebarandeh.com/data/banner/gold.png',
                message: "تبریییییک !!!!\n 2 سکه جایزه گرفتی !\nتو هم میتونی تو لیگ های ویژه جوایز میلیونی رو برنده شدی، شانستو امتحان کن...\n تخفیف های فروشگاه به مدت محدود فعال هستند ، از دستش نده",
                prizeType: "golden",
                prizeVal: 2
            },
            style: {
                completed:5,
                root: {
                    flexGrow: 1,
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize:'100% 100%',
                    backgroundRepeat: 'no-repeat',
                    width:'100%',
                    backgroundColor:"#343168",
                    backgroundBlendMode:'soft-light',
                    flex:1,
                    minHeight:'0'
                },
                mainRow: {
                    margin: 'auto',
                    width: '95%',
                    padding: 'auto',
                    overflow:'hidden',
                    flex:1,
                    minHeight:'0',
                    // marginTop:'-80px'
                },
                paper: {
                    textAlign: 'center',
                    display:'flex',
                    justifyContent:'center',
                    color: 'red',
                    height:'200px',
                    alignItems:'center',
                    margin:'10px'
                },
                starSection:{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems:'flex-start',
                    position:'relative',
                    animation: 'x 10s',
                    maxHeight: '300px',
                    animationName: Radium.keyframes(bounce, 'bounce')
                },
                roundLight:{
                    // position:'relative',
                    width:'67%'
                },
                starShow:{
                    position:'absolute',
                    width:'95%'
                },
                star: {
                    textAlign: 'center',
                    width: '50%',
                    position:'absolute',
                },
                picoLogo: {
                    marginLeft:'auto',
                    zIndex:'100',
                    position:'absolute',
                    fontSize: '3rem'
                },
                giftBox:{
                    position:'absolute',
                    width:'15%',
                    bottom:'0',
                    left:'0'
                },
                discountGreenIcon:{
                    position:'absolute',
                    width:'100%',
                    height:'100%'
                },
                discountLight:{
                    position:'absolute',
                    width:'60%',
                    top:'0',
                },
                discountText:{
                   color:'white',
                   position:'absolute',
                   bottom: '0',
                   textAlign:'center'
                },
                giftHall:{
                    position:'absolute',
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    overflow:'hidden',
                    height:'35%',
                    width:'20%',
                    bottom: '0',
                    right: '0',
                    zIndex: '200',
                    cursor:'pointer'
                },
                discountTreasure:{
                    // width:'60%',
                    // zIndex:'2'
                },
                progressSection:{},
                LeagueSection:{
                    margin:'auto',
                    textAlign:'center',
                    display:'flex',
                    justifyContent:'center',
                    alignItems: 'center',
                    position:'relative',
                    cursor:'pointer',
                    maxHeight:'60px'

                },
                startButton:{
                    width:'100%',
                },
                startText:{
                    color:'white',
                    position:'absolute',
                }
            },
            dailyGiftDialogVisible:false,
            dailyGiftDialogData:null,
            dailyGiftSec:0
        }
    }
    giftBoxClicked=async ()=>{
        this.setState({
            boxDialog:true
        })
        await axios.get(giftLogoGet)
            .then(res => {
                this.props.data({coinType:res.data.prizeType,value:res.data.prizeVal,type:'increment'},COINCHANGE)
                this.setState({
                    boxDetail:{
                        ...this.state.boxDetail,
                        ...res.data
                    }
                },()=>{
                    this.setState({
                        boxDialog:true
                    })
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )

    }
    fetchData= async()=>{
            await axios.get(userData)
            .then(res => {
                const {data}=res
                this.props.data(data)
                this.setState({
                    allDataLoaded:true,
                    dailyGiftSec:data.dailyCoin.sec
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    giftHall= async()=>{
            await axios.get(giftHallCheck)
            .then(res => {
                const {data}=res
                this.setState({
                    giftHallCheck:data
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    dailyGift= async()=>{
            await axios.get(dailyGift)
            .then(res => {
                const {data}=res
                this.setState({
                    dailyGiftSec:data.dailyCoin.sec
                })
                const icon = data.type==='golden'?goldCoin:silverCoin
                const text = data.type==='golden'?'طلا':'نقره'
                this.props.data({coinType:data.type,value:data.value,type:'increment'},COINCHANGE)

                const obj= {
                        dialog:{
                            id: 0,
                            icon:icon,
                            title: "خطا",
                            message: `تبریک ${data.value} سکه ${text} دریافت کردید .`,
                            ok: null,
                            cancel: {
                                text: "باشه",
                                action: "#ok"
                            },
                            style: {
                                type: "danger",
                                borderColor: dialogBorderColor,
                                background: dialogBackground,
                                contentColor: dialogContentColor,
                                contentTextColor: dialogContentTextColor
                            }
                        }
                    }
                this.setState({
                    dailyGiftDialogData:obj.dialog,
                },()=>{
                    this.setState({
                        dailyGiftDialogVisible:true
                    })
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    giftCheck= async()=>{
            await axios.get(giftLogoCheck)
            .then(res => {
                const {data}=res
                if (data.success)
                    this.setState({
                        giftLogoCheck:true
                    })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    handleSpecialOffer=async()=>{
        this.setState({
            showDialog:true,
        })

            await axios.get(actionMainGet)
                .then(res => {
                    const {data}=res
                    // if (data.success)
                        this.setState({
                            specialDialogData:data
                        })
                }).catch(error=>{
                        console.log(error.toString())
                    }
                )

         this.setState({
             showDialog:true,
         })
    }
    fetchSpecialDialogOffer=async ()=>{
        await axios.get(actionMainGet)
            .then(res => {
                const {data}=res
                // if (data.success)
                this.setState({
                    specialDialogData:data
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    handleFreeCoins=async (data)=>{
        if (data.type==='url'){
            this.props.history.push(data.onClick)
        }
        if (this.state.dailyGiftSec==0){
            await this.dailyGift()
            this.fetchData()
        }
    }
    componentDidUpdate() {
        if (this.props.UserData.userData!=null)
            if (!this.state.rxDataLoaded)
                this.setState({
                    rxDataLoaded:true
                })
    }
    async componentDidMount() {
        // window.history.pushState(null, document.title, window.location.href);
        // window.addEventListener('popstate', function (event) {
        //     if (this.state.showDialog){
        //         this.setState({
        //             showDialog:false
        //         },()=>{
        //             window.history.pushState(null, document.title,  window.location.href);
        //         })
        //     }else {
        //         window.history.back()
        //     }
        // }.bind(this));
        await this.fetchData()
        this.giftHall()
        this.giftCheck()
        this.fetchSpecialDialogOffer()
        this.props.toggleBottomNavbar(true)
        const freeCoinItems=[
            {
                text:'گنج روزانه',
                backgroundImage:blurBackground,
                image:coinBox,
                hasAnimation:false
            },
            {
                text:'گنج روزانه',
                backgroundImage:blurBackground,
                image:coinBox,
                hasAnimation:false
            },
        ]
    }
    handleDialogAction=(action)=>{
        switch (action) {
            case '#cancel':
                this.setState({
                    dailyGiftDialogVisible:false,
                })
                break
            default:
                this.setState({
                    dailyGiftDialogVisible:false,
                })
        }
    }
    handleBoxDialogAction=(action)=>{
        switch (action){
            case 'close':
                this.setState({
                    boxDialog:false
                },()=>{
                    this.setState({
                        giftLogoCheck: false
                    })
                })
                break
            case 'game':
                this.setState({
                    boxDialog:false
                },()=>{
                    this.setState({
                        giftLogoCheck: false
                    })
                    this.props.history.push('/league-start')
                })
        }
    }
    render() {
        const handleClose=(()=>{
            this.setState({
                showDialog:false,
                dailyGiftDialogVisible:false
            })
        })
        const handleBoxDialogClose=(()=>{
            this.setState({
               boxDialog:false
            })
        })
        const freeCoinItems=[
            {
                id:'dailyGift',
                text:'گنج روزانه',
                backgroundImage:blurBackground,
                image:coinBox,
                hasAnimation:true,
                onClick:null,
                type:'dialog',
                remainingTime:this.state.dailyGiftSec
            },
            {
                id:'luckSpinner',
                text:'گردونه شانس',
                backgroundImage:blurBackground,
                image:gardoone,
                hasAnimation:false,
                onClick:"/home/luck-spinner",
                type:'url',
                remainingTime:'0'
            },
        ]
        const {trueState,giftHallCheck,giftLogoCheck}=this.state
        const customDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            cancelButton:{
                text:'خروج',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'#ffffff',
                borderColor:'transparent',
            },
            exitButton:{
                text:'تلاش مجدد',
                backgroundColor:'green',
                bottomFontSize:'15px',
                buttonTextColor:'#ffffff',
                borderColor:'transparent'
            },
            data:{
                icon:Exit,
                text:'خطا در برقراری اتصال ، اینترنت خود را بررسی کنید'
            }
        }
        const data=this.props.UserData.userData
        const {rxDataLoaded,boxDialog,specialDialogData,dailyGiftDialogData}= this.state
        const boxDetail={
            success: true,
            light:roundLight,
            type: "gift",
            strAction: "بریم  بازی",
            action: "#game",
            imgUrl: 'http://hooshebarandeh.com/data/banner/gold.png',
            message: "تبریییییک !!!!\n 2 سکه جایزه گرفتی !\nتو هم میتونی تو لیگ های ویژه جوایز میلیونی رو برنده شدی، شانستو امتحان کن...\n تخفیف های فروشگاه به مدت محدود فعال هستند ، از دستش نده",
            prizeType: "golden",
            prizeVal: 2
    }
        const specialDialogDetail={
            success: true,
            light:roundLight,
            type: "gift",
            strAction: "بریم  بازی",
            action: "#game",
            imgUrl: 'http://hooshebarandeh.com/data/banner/gold.png',
            message: "تبریییییک !!!!\n 2 سکه جایزه گرفتی !\nتو هم میتونی تو لیگ های ویژه جوایز میلیونی رو برنده شدی، شانستو امتحان کن...\n تخفیف های فروشگاه به مدت محدود فعال هستند ، از دستش نده",
            prizeType: "golden",
            prizeVal: 2,
            ...specialDialogData
        }
        const dailyGiftDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog:dailyGiftDialogData,
            }
        }
        return(
            <Grid direction={"column"} item container style={this.state.style.root}>
                {
                    this.state.allDataLoaded &&
                    <Grid item sm={12} xs={12} direction={"column"} justify={'center'} container
                          style={{flex:'1',minHeight:'0',overflow:'visible'}}

                    >
                        <Dialog
                            // disableBackdropClick
                            open={this.state.dailyGiftDialogVisible}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            style={{background:'transparent !important'}}
                            PaperProps={{
                                style: {
                                    backgroundColor: 'transparent',
                                    boxShadow: 'none',
                                },
                            }}
                        >
                            <DialogContent>
                                <CustomDialog action={this.handleDialogAction} data={dailyGiftDialog}/>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={this.state.showDialog}
                            // open={true}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            style={{background:'transparent !important'}}
                            PaperProps={{
                                style: {
                                    backgroundColor: 'transparent',
                                    boxShadow: 'none',
                                    overflow:'visible'
                                },
                            }}
                        >
                            <DialogContent style={{overflow:'visible'}}>
                                <SpecialOfferDialog data={specialDialogDetail}/>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={boxDialog}
                            // open={true}
                            onClose={handleBoxDialogClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            style={{background:'transparent !important'}}
                            PaperProps={{
                                style: {
                                    backgroundColor: 'transparent',
                                    boxShadow: 'none',
                                    overflow:'visible'
                                },
                            }}
                        >
                            <DialogContent style={{overflow:'visible'}}>
                                <BoxDialog action={this.handleBoxDialogAction} data={this.state.boxDetail}/>
                            </DialogContent>
                        </Dialog>
                        <Grid item container id={'asd'}>
                            <Toolbar type='mainToolbar'/>
                        </Grid>
                        <Grid item container xs={12} justify={"center"} sm={12} alignContent={"flex-start"} className='scrollBar'
                              style={{flex:'1',minHeight:'0',overflow:'auto' ,marginTop:'10px'}}>
                            <Grid justify={"center"} container spacing={3} style={this.state.style.mainRow}>
                                <Grid container justify={"center"} item sm={11} xs={11} style={this.state.style.starSection}>
                                    <img src={roundLight} className="lightAnimation" style={this.state.style.roundLight}/>
                                    <img src={starShow} style={this.state.style.starShow}/>
                                    <img src={star} style={this.state.style.star}/>
                                    <p style={this.state.style.picoLogo} className={'main-star'}>
                                        {numberSplitor(data.stats.stars)}
                                    </p>
                                    {
                                        giftLogoCheck &&
                                        <img src={giftBox} className="giftBox" style={this.state.style.giftBox}
                                             onClick={()=>{
                                                 this.giftBoxClicked()
                                             }}
                                        />
                                    }
                                    {/*<img src={giftBox} style={this.state.style.giftBox}/>*/}
                                    {
                                        specialDialogData &&
                                        <Grid container className='home-special-offer clickable' item
                                              onClick={()=>{
                                                  this.handleSpecialOffer()
                                              }}
                                        >
                                            <img src={giftHallBackground}
                                                 style={this.state.style.discountGreenIcon}
                                            />
                                            <img src={roundLight}
                                                 style={this.state.style.discountLight}
                                            />
                                            <img className='home-special-offer-icon'
                                                 src={specialDialogData.data.iconMain}
                                            />
                                            <h5
                                                style={this.state.style.discountText}
                                            >
                                                پیشنهاد ویژه
                                            </h5>
                                        </Grid>
                                    }
                                    {
                                        (giftHallCheck && giftHallCheck.active) &&
                                        <Grid onClick={()=>{
                                            this.props.history.push('/home/gift-hall')
                                        }} container item style={this.state.style.giftHall}>
                                            <img src={giftHallBackground}
                                                 style={this.state.style.discountGreenIcon}
                                            />
                                            <img src={roundLight}
                                                 style={this.state.style.discountLight}
                                            />
                                            <img src={giftHallCheck.small_icon} className='home-special-offer-icon'
                                                 style={this.state.style.discountTreasure}
                                            />
                                            <h5
                                                style={this.state.style.discountText}
                                            >
                                                تالار جایزه
                                            </h5>
                                        </Grid>
                                    }
                                    <Grid xs={5} sm={5} container justify={"center"} alignItems={"center"} item
                                               className='home-rank-banner'
                                               style={{
                                                   backgroundImage: "url(" + GoldBanner + ")",
                                                   transform:'translateY(10px)',
                                                   position:'absolute'
                                               }}>
                                        <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}/>
                                        <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                            <p style={{
                                                color:'#ffffff',
                                                // transform:'translateY(-10px)'
                                            }}>
                                                { rxDataLoaded? data.stats.league: 'loading' }
                                            </p>
                                        </Grid>
                                        <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                        <img src={rxDataLoaded?data.stats.league_logo:''} style={{width:'100%',transform:'translateY(-10px)'}} alt=""/>
                                    </Grid>
                                    </Grid>
                                </Grid>
                                <Grid alignItems={"center"} justify={"space-around"} container item sm={10} xs={10}
                                      className='home-next-prize'>
                                    <Grid container alignItems={"center"} item sm={7} xs={7}
                                        style={{
                                            height:'35px'
                                        }}
                                    >
                                        <PrizeProgress/>
                                    </Grid>
                                    <Grid className='next-prize' container justify={"center"} alignItems={"center"} item sm={3} xs={3}>
                                        <p style={{
                                        fontSize:'2vh'}
                                        }>
                                            جایزه بعدی
                                            {rxDataLoaded?
                                                numberSplitor(data.stats.prize)
                                                :'loading'}
                                            <span>
                                        {rxDataLoaded?
                                            data.stats.prizeModel
                                            :'loading'}
                                    </span>
                                        </p>
                                    </Grid>
                                </Grid>
                                <CSSTransition
                                    in={trueState}
                                    appear={true}
                                    timeout={1000}
                                    classNames="test"
                                >
                                    <Grid className='clickable' item sm={10} xs={10} style={this.state.style.LeagueSection}
                                          onClick={()=>this.props.history.push('league-start')}>
                                        {/*<img src={startButton} style={this.state.style.startButton}/>*/}
                                        <Grid container alignItems={"center"} justify={"flex-start"}
                                            style={{
                                                backgroundImage: "url(" + startButton + ")",
                                                backgroundSize: 'contain',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'center',
                                                maxHeight:'125px'
                                            }
                                            }
                                        >
                                            <Grid container alignItems={"center"} justify={"center"} sm={11} xs={11}>
                                                <p style={{
                                                    color:"#ffffff",
                                                    fontSize:'3vh',
                                                    maxHeight:'85px'
                                                }} >
                                                    شروع لیگ
                                                </p>
                                            </Grid>

                                        {/*</Grid>*/}
                                        {/*    */}
                                        {/*</Grid>*/}

                                        </Grid>
                                    </Grid>
                                </CSSTransition>


                                <Grid container
                                      style={{maxHeight:'55px'}}
                                      justify={"flex-end"} alignContent={"center"} alignItems={"center"} item sm={10} xs={10}
                                >
                                    <h2 style={{textAlign:'right',color:'white'}}>
                                        :سکه رایگان
                                    </h2>
                                </Grid>
                                <CSSTransition
                                    in={trueState}
                                    appear={true}
                                    timeout={1000}
                                    classNames="bottom-translate"
                                >
                                    <Grid alignItems='center' alignContent="center"  item sm={10} xs={10} container justify="center"
                                          style={{marginBottom:'30px'}}>
                                        {
                                            freeCoinItems.map(data=>{
                                                return <Grid item sm={4} xs={4}
                                                             style={{
                                                                 maxHeight: '150px'
                                                             }}
                                                             onClick={()=>this.handleFreeCoins(data) }
                                                >
                                                    <FreeCoinItem data={data} />
                                                </Grid>})
                                        }
                                    </Grid>
                                </CSSTransition>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                {
                    !this.state.allDataLoaded &&
                    <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                          style={{position:'relative',
                              top:'50%',left:'50%',transform:'translate(-50%,-50%)'}}
                    >
                        <Grid item container justify={"center"} style={{position:'absolute',
                        }}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>
                }
            </Grid>
        )
    }
}
const homeIndex=withRouter (HomeIndex)
const mapStateToProps=state=>({
    UserData:state.UserData
})
export default connect(mapStateToProps,{data})(homeIndex)